import { render } from "./settingsContent.vue?vue&type=template&id=309e46ee&scoped=true"
import script from "./settingsContent.vue?vue&type=script&lang=js"
export * from "./settingsContent.vue?vue&type=script&lang=js"

import "./settingsContent.vue?vue&type=style&index=0&id=309e46ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309e46ee"]])

export default __exports__